import { Component, OnInit } from "@angular/core";
import { merge, Observable, of as observableOf, Subscription } from "rxjs";
import {
  startWith,
  switchMap,
  map,
  catchError,
  finalize,
} from "rxjs/operators";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { DashboardPersonnelService } from "../../../core/service/dashboard-personnel.service";
import { PageDashboardDossierCredit } from "../../../core/model/PageDashboardDossierCredit";

@Component({
  selector: "app-dossiers-list",
  templateUrl: "./dossiers-list.component.html",
  styleUrls: ["./dossiers-list.component.scss"],
})
export class DossiersListComponent implements OnInit {
  isLoading$: Observable<boolean>;
  tab: string = "";
  label: string = "";
  subscription!: Subscription;
    state: String = "_";

  //Loader par cardView
  isLoading: boolean = false;
  pageSize: number = 10; // Number of items to display per page
  pageIndex: number = 0; // Number of
  paginatedItems: PageDashboardDossierCredit;
  filter: string;
  username: string = null;
  constructor(
    private _dashboardPersonnelService: DashboardPersonnelService,
    private _keycloakService: KeycloakService
  ) {
    this.username = _keycloakService.getUsername();
  }

  ngOnInit() {
    //this.getDossiersPersonnelStatus("", 0);
        this.getDossiersPersonnelStatus("", this.state, 0);

    //    this.getDossiersPersonnel("", 0);

  }
   filterByState(): void {
    this.getDossiersPersonnelStatus("", this.state, 0);
  }


  getDossiersPersonnelStatus(filter: string,state: String, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardPersonnelService.getDossiersPersonnel(
            actualFilter,
            page,
            this.pageSize,
            this.username,
            state
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((data) => {
        this.paginatedItems = data;
      });
  }

  goToPage(page: number) {
    if (page >= 0) {
      this.pageIndex = page;
   //   this.getDossiersPersonnelStatus(this.filter, page);
              this.getDossiersPersonnelStatus(this.filter, this.state, page);

    }
  }


  

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue.trim().toLowerCase();
    this.pageIndex = 0; // Number of
   // this.getDossiersPersonnelStatus(this.filter, this.pageIndex);
                  this.getDossiersPersonnelStatus(this.filter, this.state,  this.pageIndex);

  }
  pageSizeChanged() {
    this.pageIndex = 0; // Number of
   // this.getDossiersPersonnelStatus(this.filter, this.pageIndex);
    this.getDossiersPersonnelStatus(this.filter, this.state,  this.pageIndex);

  }

}
